import { render, staticRenderFns } from "./LegalService.vue?vue&type=template&id=02a876fe&scoped=true"
import script from "./LegalService.vue?vue&type=script&lang=js"
export * from "./LegalService.vue?vue&type=script&lang=js"
import style0 from "./LegalService.vue?vue&type=style&index=0&id=02a876fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a876fe",
  null
  
)

export default component.exports